// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__ZGJ6j","footer":"ModalFilter_footer__3i5KS"};